@let currentJob = job();
<div
  class="tw-flex tw-flex-col tw-p-3 tw-rounded-lg tw-border tw-font-inter"
  [ngClass]="{
    'tw-gap-3 tw-bg-blue-50 tw-border-blue-200': currentJob.status === 'processing',
    'tw-gap-2 tw-bg-gray-50 tw-border-gray-200': currentJob.status === 'completed',
    'tw-gap-2 tw-bg-red-50 tw-border-red-300': currentJob.status === 'failed'
  }"
>
  <div class="tw-flex tw-flex-col tw-gap-3 lg:tw-gap-2">
    <!-- header: title + channel | initiator -->
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-1 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between lg:tw-gap-3">
      <p class="tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-max-w-full lg:tw-max-w-[70%] tw-text-sm tw-font-semibold tw-leading-normal tw-text-gray-700 tw-whitespace-nowrap">
        <app-truncation-tooltip [text]="title()" [hostNgClass]="'tw-font-semibold'" />
        <span class="tw-shrink-0">({{ processedCount() | number }} / {{ currentJob.total | number }})</span>
      </p>
      <div class="tw-flex tw-items-center tw-justify-end tw-gap-1 tw-min-w-0 tw-max-w-full lg:tw-flex-1">
        @if (channelIcon(); as channelIconSvg) {
        <span class="tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-w-[21px]" [innerHTML]="channelIconSvg | safe"></span>
        <span class="tw-shrink-0 tw-w-px tw-h-[15px] tw-rounded-lg tw-bg-gray-300"></span>
        }
        <span class="tw-flex tw-items-center tw-gap-1 tw-min-w-0">
          <span class="tw-flex tw-shrink-0" [innerHTML]="icons.user | safe"></span>
          <app-truncation-tooltip [text]="currentJob.by" [hostNgClass]="'tw-text-xs tw-leading-3 tw-text-gray-500'" />
        </span>
      </div>
    </div>

    @if (currentJob.status === 'processing') {
    <div
      role="progressbar"
      aria-valuemin="0"
      [attr.aria-valuenow]="processedCount()"
      [attr.aria-valuemax]="currentJob.total"
      class="tw-relative tw-w-full tw-h-1.5 tw-rounded-sm tw-bg-gray-300"
    >
      <div class="tw-absolute tw-inset-y-0 tw-start-0 tw-rounded-sm tw-bg-blue-600" [style.width.%]="progressPercent()"></div>
    </div>
    }
    <!-- event + persona chips -->
    <div class="tw-flex tw-items-start tw-gap-2 tw-min-w-0">
      @for (chipText of chips(); track $index) {
      <span class="tw-flex tw-min-w-0 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-bg-gray-200 tw-max-w-[130px] lg:tw-max-w-[173px]">
        <app-truncation-tooltip [text]="chipText" [hostNgClass]="'tw-text-xs tw-leading-normal tw-text-gray-900'" />
      </span>
      }
    </div>
    @if (currentJob.status === 'completed') {
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-3 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between">
      <div class="tw-flex tw-items-center tw-gap-3 tw-text-xs tw-font-medium tw-leading-3 tw-text-gray-700 tw-whitespace-nowrap">
        <span class="tw-flex tw-items-center tw-gap-1.5">
          <span class="tw-flex" [innerHTML]="icons.succeeded | safe"></span>
          {{ currentJob.succeeded | number }} {{ resultLabel() }}
        </span>
        @if (currentJob.total_skipped > 0) {
        <span class="tw-flex tw-items-center tw-gap-1">
          <span class="tw-flex tw-items-center tw-gap-1.5">
            <span class="tw-flex tw-p-px" [innerHTML]="icons.skipped | safe"></span>
            {{ currentJob.total_skipped | number }} {{ skippedLabel }}
          </span>
          @if (skippedReasons().length) {
          <span
            tabindex="0"
            class="tw-flex tw-p-0.5 tw-cursor-pointer"
            [attr.aria-label]="skippedDetailsLabel"
            [ngxTippy]="skippedReasonsTooltip"
            [tippyProps]="{ theme: 'dark', placement: 'top' }"
            [innerHTML]="icons.info | safe"
          ></span>
          <ng-template #skippedReasonsTooltip>
            <ul class="tw-list-disc tw-ps-4 tw-m-0">
              @for (reason of skippedReasons(); track reason.label) {
              <li class="tw-text-xs tw-font-medium tw-font-inter tw-leading-normal tw-text-white">{{ reason.count | number }} {{ reason.label }}</li>
              }
            </ul>
          </ng-template>
          }
        </span>
        }
      </div>
      @if (canDownloadReport()) {
      <button
        type="button"
        (click)="downloadReport()"
        [attr.aria-busy]="isDownloading()"
        class="tw-flex tw-items-center tw-gap-1.5 tw-py-px tw-rounded-md tw-text-xs tw-font-medium tw-leading-normal tw-text-blue-600 tw-whitespace-nowrap"
      >
        @if (isDownloading()) {
        <span class="tw-relative tw-flex tw-w-3 tw-h-3">
          <progress-circle class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-scale-[0.43]" colorClasses="tw-border-blue-600 tw-border-r-transparent" />
        </span>
        } @else {
        <span class="tw-flex" [innerHTML]="icons.download | safe"></span>
        }
        {{ downloadReportLabel }}
      </button>
      }
    </div>
    }

    @if (currentJob.status === 'failed') {
    <div class="tw-flex tw-items-start tw-gap-1">
      <span class="tw-flex tw-shrink-0 tw-p-px tw-mt-[3px]" [innerHTML]="icons.failed | safe"></span>
      <p class="tw-text-xs tw-font-medium tw-leading-normal tw-text-red-600">{{ failedMessage() }}</p>
    </div>
    }
  </div>
</div>
